import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsService } from './services.index';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SettingsService
  ]
})
export class ServicesModule { }
